import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <polygon points="46.33 9.33 40.67 3.67 25 19.34 9.33 3.67 3.67 9.33 19.34 25 3.67 40.67 9.33 46.33 25 30.66 40.67 46.33 46.33 40.67 30.66 25 46.33 9.33" />
  </Base>
);
